
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MappingService {

  constructor(private readonly http: HttpClient) { }


  saveCategoryMapping(data) {
    return this.http.post(`${environment.api_url}mapping/categories`, data);
  }

  saveAttributeMapping(data) {
    return this.http.post(`${environment.api_url}mapping/attribute`, data);
  }

  saveValueMapping(data) {
    return this.http.post(`${environment.api_url}mapping/values/save`, data);
  }

  getAttributesMapping(importId) {
    let params= new HttpParams().set('importId', importId);
    return this.http.get(`${environment.api_url}mapping/attributes`, { params });
  }

  getValuesMapping(data) {
    return this.http.post(`${environment.api_url}mapping/values`, data);
  }

  getLookupValuesOfAttribute(attributeCode, locale) {
    let params= new HttpParams().set('attributeCode', attributeCode).set('locale', locale);
    return this.http.get(`${environment.api_url}mapping/attribute/values`, { params });
  }

  checkImportMapping(importId): Observable<boolean> {
    let params= new HttpParams().set('importId', importId);
    return this.http.get<boolean>(`${environment.api_url}import/interrupted/mapping`, { params });
  }

  validateMapping(importId, skipErrors: boolean): Observable<string> {
    let params= new HttpParams().set('importId', importId).set('skipErrors', skipErrors);
    return this.http.post<string>(`${environment.api_url}import/valid/mapping`, null , { params });
  }

  changeImportStatus(data): Observable<string> {
    return this.http.post<string>(`${environment.api_url}import/status`, data);
  }

  getFinalIdentifiedCategories(importId): Observable<number> {
    let params= new HttpParams().set('importId', importId);
    return this.http.get<number>(`${environment.api_url}mapping/valid`, { params });
  }
}
